module.exports = __webpack_public_path__ + "static/media/Blog.3ba364ab.png";